import { render, staticRenderFns } from "./LoadingBig.vue?vue&type=template&id=36e82154&scoped=true"
import script from "./LoadingBig.vue?vue&type=script&lang=js"
export * from "./LoadingBig.vue?vue&type=script&lang=js"
import style0 from "./LoadingBig.vue?vue&type=style&index=0&id=36e82154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e82154",
  null
  
)

export default component.exports